import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../api/authApi";
import { isAdminLoggedIn, persistAdminSession } from "../utils/adminSession";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loginError, setLoginError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAdminLoggedIn()) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.email.trim() || !formData.password.trim()) {
      setLoginError("Please enter both email and password.");
      return;
    }

    setIsSubmitting(true);
    setLoginError("");

    try {
      const response = await login(formData.email.trim(), formData.password);
      const payload = response?.data ?? response?.Data ?? response;
      const loginSucceeded =
        payload?.success === true ||
        payload?.Success === true ||
        payload?.isSuccess === true ||
        payload?.IsSuccess === true;

      if (!loginSucceeded) {
        setLoginError(payload?.message || payload?.Message || response?.message || response?.Message || "Login failed.");
        return;
      }

      const admin = payload?.admin || payload?.user || {
        userId: payload?.userId,
        userName: payload?.userName,
        email: payload?.email || formData.email.trim(),
      };

      persistAdminSession(admin);
      navigate("/admin/dashboard", { replace: true });
    } catch (error) {
      setLoginError(error?.message || "Unable to login right now.");
    } finally {
      setIsSubmitting(false);
    }
  };

return (
  <main className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
    <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl border border-gray-200 p-8">
      <div className="flex flex-col items-center">
        <img
          src="/ImageAndVideo/logo/withoutbg.png"
          alt="AegisCare"
          className="h-16 mb-4"
        />

        <h1 className="text-2xl font-bold text-maroon">
          Admin Login
        </h1>

        <p className="text-sm text-gray-500 mt-2 text-center">
          Sign in to access the admin dashboard.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mt-8 space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>

          <input
            id="admin-email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter email"
            className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-maroon"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>

          <input
            id="admin-password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder="Enter password"
            className="w-full rounded-lg border border-gray-300 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-maroon"
            required
          />
        </div>

        {loginError && (
          <div className="rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm p-3">
            {loginError}
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full rounded-lg bg-maroon py-3 text-white font-semibold hover:bg-maroon-dark transition disabled:opacity-60"
        >
          {isSubmitting ? "Signing in..." : "Login"}
        </button>
      </form>

      <div className="mt-6 text-center">
        <Link
          to="/"
          className="text-sm text-maroon hover:underline"
        >
          ← Back to Website
        </Link>
      </div>
    </div>
  </main>
);
}

export default AdminLoginPage;
